import type { StyleRule } from '@archipro-design/aria';
import { logoClassName } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import {
    buttonClassName,
    navigationListClassName,
} from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { labelClassName } from '@fluentui/react-northstar';
import { LEFT_SIDE_WIDTH } from '~/modules/design-board/config';

export const LeftSideContent: StyleRule = ({
    theme,
    hasTitle,
    isBoardDetailPage,
}) => ({
    height: '100vh',
    width: pxToRem(LEFT_SIDE_WIDTH),
    minWidth: pxToRem(LEFT_SIDE_WIDTH),
    padding: pxArrayToRem([18, 28, 0, 28]),

    [theme.screen.clamped]: {
        paddingLeft: pxToRem(3),
    },

    '> a': {
        textDecoration: 'none',
        color: theme.siteVariables.colors.charcoal['250'],
        display: 'block',
        [`& .${logoClassName}`]: {
            display: 'block',
            margin: pxArrayToRem([5, 0, 0, -5]),
            '& svg': {
                width: pxToRem(265.4),
                height: pxToRem(51),
            },
        },
    },

    [`& .${navigationListClassName}`]: {
        margin: hasTitle ? 0 : pxArrayToRem([28, 0, 50, -3]),

        [`& > .${captionClassName}`]: {
            fontSize: pxToRem(18),
            fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: pxToRem(221),
            display: 'block',
            whiteSpace: 'nowrap',
            margin: hasTitle ? pxArrayToRem([77, 0, 51, -9]) : 0,
            [`& .${svgIconClassName}`]: {
                width: pxToRem(24),
                margin: pxArrayToRem([0, 1, 0, -1]),
                '& svg': {
                    marginTop: pxToRem(-1),
                },
            },
        },

        [`& .${buttonClassName}`]: {
            ':hover': {
                textDecoration: 'none',
            },
            height: pxToRem(32),
            margin: pxArrayToRem(
                isBoardDetailPage ? [0, 0, 10, -3] : [0, 0, 18, 0]
            ),

            [`& .${labelClassName}`]: {
                fontSize: pxToRem(isBoardDetailPage ? 20 : 24),
                fontWeight:
                    theme.siteVariables.textStyles.Text.Medium65.fontWeight,
                letterSpacing: theme.siteVariables.letterSpacingSmall,
            },

            '& .active': {
                display: 'block',
                height: pxToRem(isBoardDetailPage ? 30 : 33),
                marginTop: pxToRem(isBoardDetailPage ? 6 : 12),
                borderBottom: `2px solid ${theme.siteVariables.colors.charcoal['000']}`,
            },
        },
    },
});

export const PreviewTag: StyleRule = ({ theme }) => ({
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    color: theme.siteVariables.colors.primitive.white,
    fontSize: pxToRem(10),
    lineHeight: pxToRem(10),
    padding: pxArrayToRem([4, 6]),
    background: theme.siteVariables.colors.grey[300],
    marginLeft: pxToRem(10),
    marginTop: pxToRem(4),
    borderRadius: pxToRem(2),
});

export const PreviewItem: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.grey[300],
    display: 'flex',
    alignItems: 'center',
});

export const LeftSideNavFilterWrapper: StyleRule = () => ({
    padding: pxArrayToRem([26, 0, 0, 3]),
});
